<div class='availability interested-container'>
  <form [formGroup]="form">
    <div class="section-container">
      <app-file-upload (uploadSuccessEvent)="resumeUploadedHandler($event)"
        (resumeUploadingEvent)="resumeUploadingHandler($event)"
        [talentId]="gather.talentPersonId"
      [fileUploadUserType]="fileUploadUserType"></app-file-upload>
    </div>

    <div class="section-container">
      @if (!payTransparencyFeature && (jobPosting && jobPosting.firmPay === false)) {
        <div>
          <div class="header-text">{{'gather.interested.compensation-and-availability' | translate}}</div>
          <div class="subheader-text">{{'gather.interested.desired-pay' | translate}}</div>
        </div>
        <div class="new">
          @if (jobPosting && (jobPosting.placementTypeId === 1 || jobPosting.placementTypeId === 2)) {
            <mat-form-field style="width: 100%">
              <mat-label>{{'gather.interested.enter-annual-salary' | translate}}</mat-label>
              <input matInput formControlName="salary" id="salary-input" type="text">
            </mat-form-field>
          } @else if (jobPosting && jobPosting.placementTypeId === 3) {
            <mat-form-field style="width: 100%">
              <mat-label>{{'gather.interested.enter-hourly-rate' | translate}}</mat-label>
              <input matInput formControlName="hourlyRate" id="hourly-rate-input" type="text">
            </mat-form-field>
          } @else if (jobPosting && jobPosting.placementTypeId === 4) {
            <mat-form-field style="width: 100%">
              <mat-label>{{'gather.interested.enter-total-compensation' | translate}}</mat-label>
              <input matInput formControlName="projectRate" id="project-rate-input" type="text">
            </mat-form-field>
          } @else {
            <mat-form-field style="width: 100%">
              <input matInput formControlName="projectRate" id="project-rate-input" type="text">
            </mat-form-field>
          }
        </div>
      } @else {
        <div>
          <div class="header-text">{{'gather.interested.availability' | translate}}</div>
        </div>
      }

      <div class="available-to-start">
        <label id="available-to-start-radio-group-label" class="subheader-text">{{"talent-happy-path.talent-profile.opportunities.when-available" | translate}}</label>
        <mat-radio-group aria-labelledby="available-to-start-radio-group-label" class="available-to-start-radio-group" formControlName="availabilityType">
          <div class="availability-label">
            <mat-radio-button [value]="getAvailabilityType('now')" aria-labelledby="label-immediately"></mat-radio-button>
            <span id="label-immediately">{{"gather.interested.immediately" | translate}}</span>
          </div>
          <div class="availability-label">
            <mat-radio-button [value]="getAvailabilityType('specificDate')" aria-labelledby="label-specificDate"></mat-radio-button>
            <span id="label-specificDate">{{"talent-happy-path.talent-profile.opportunities.availability-types.date" | translate}}</span>
          </div>
          <div class="availability-label">
            <mat-radio-button [value]="getAvailabilityType('withNotice')" aria-labelledby="label-withNotice"></mat-radio-button>
            <span id="label-withNotice">{{"talent-happy-path.talent-profile.opportunities.availability-types.notice" | translate}}</span>
          </div>
        </mat-radio-group>

        @if (availabilityType?.value === talentProfileStartAvailability.WITH_NOTICE) {
          <mat-form-field style="width: 100%" class="weeks-notice-input">
            <mat-label>{{"talent-happy-path.talent-profile.opportunities.availability-types.weeks-notice" | translate}}</mat-label>
            <input matInput type="text" formControlName="numWeeksNoticeNeeded">
            <mat-error>{{"gather.interested.non-integer-number-of-weeks-error" | translate}}</mat-error>
          </mat-form-field>
        }

        @if (availabilityType?.value === talentProfileStartAvailability.SPECIFIC_DATE) {
          <app-date-picker [(selectedDate)]="availabilityDate"
            (selectedDateChange)="onAvailabilityDateChange($event)"
            [personId]="this.gather.talentPersonId">
          </app-date-picker>
        }
      </div>
    </div>

    <div class="section-container">
      <div class="header-text">{{'gather.interested.location' | translate}}</div>
      <app-location-picker [formGroup]="form" [talent]="talent" [required]="false"></app-location-picker>
    </div>

    <div class="row medium-margin form-option do-not-display">
      <div class="small-11 small-centered medium-8 large-7 columns">
        <div class="subheader gather-subheader-padding">
          {{'gather.not-interested.tell-us-more-interested' | translate}}
        </div>
        <textarea placeholder="{{'gather.interested.optional' | translate}}" formControlName="notes"></textarea>
      </div>
    </div>

    <div class="medium-margin form-option section-container">
      <div class="full-width">
        <div class="section-header-row">
          <h3 class="section-label">{{"talent-happy-path.quick-apply.submit-page.profiles-portfolios" | translate}}</h3>
          <span class="spacer"></span>
          <span class="optional-text">{{"talent-happy-path.quick-apply.submit-page.optional-text" | translate}}</span>
        </div>

        <div class="section-group">
          <h3 class="section-label">{{ 'talent-happy-path.quick-apply.submit-page.profile' | translate }}</h3>
          <div formArrayName="profileUrls">
            @for (group of profileUrls.controls; track group; let i = $index) {
              <div [formGroupName]="i" class="url-input-wrapper">
                <mat-form-field class="full-width" subscriptSizing="dynamic">
                  <mat-label>{{"talent-happy-path.quick-apply.submit-page.professional-profile-placeholder" | translate}}</mat-label>
                  <input matInput
                    formControlName="url"
                    [placeholder]="'talent-happy-path.quick-apply.submit-page.professional-profile-placeholder' | translate"
                    (input)="clearResponseCode(group)"
                    (blur)="onUrlBlur(group)">
                  @if (profileUrls.length > 1) {
                    <button type="button"
                      mat-icon-button
                      matSuffix
                      (click)="removeProfileUrl(i)"
                      [attr.aria-label]="'Remove profile link ' + (i + 1)">
                      <mat-icon class="delete-icon">delete_outline</mat-icon>
                    </button>
                  }
                  @if (group.get('url')?.hasError('invalidUrl') || group.get('url')?.hasError('incorrect')) {
                    <mat-error>
                      @if (!group.get('responseCode')?.value || group.get('responseCode')?.value === 0) {
                        {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                      } @else if (group.get('responseCode')?.value === 403) {
                        {{"gather.error.inaccessible" | translate}}
                      } @else if (group.get('responseCode')?.value === 404) {
                        {{"gather.error.not-found" | translate}}
                      } @else {
                        {{"gather.error.general" | translate}}
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>

          <div class="add-action-row">
            <button type="button" mat-button class="add-button" (click)="addProfileUrl()" [disabled]="!canAddMore">
              <mat-icon>add</mat-icon>
              <span>{{ 'talent-happy-path.quick-apply.submit-page.add-profile' | translate }}</span>
            </button>
          </div>
        </div>

        <div class="section-group">
          <h3 class="section-label">{{ 'talent-happy-path.quick-apply.submit-page.portfolio-work' | translate }}</h3>
          <div formArrayName="portfolioUrls">
            @for (group of portfolioUrls.controls; track group; let i = $index) {
              <div [formGroupName]="i" class="portfolio-item-block">
                <mat-form-field class="full-width" subscriptSizing="dynamic">
                  <mat-label>{{"talent-happy-path.quick-apply.submit-page.portfolio-placeholder" | translate}}</mat-label>
                  <input matInput
                    formControlName="url"
                    [placeholder]="'talent-happy-path.quick-apply.submit-page.portfolio-placeholder' | translate"
                    (input)="clearResponseCode(group)"
                    (blur)="onUrlBlur(group)">
                  @if (portfolioUrls.length > 1) {
                    <button type="button"
                      mat-icon-button
                      matSuffix
                      (click)="removePortfolioUrl(i)"
                      [attr.aria-label]="'Remove portfolio link ' + (i + 1)">
                      <mat-icon class="delete-icon">delete_outline</mat-icon>
                    </button>
                  }
                  @if (group.get('url')?.hasError('invalidUrl') || group.get('url')?.hasError('incorrect')) {
                    <mat-error>
                      @if (!group.get('responseCode')?.value || group.get('responseCode')?.value === 0) {
                        {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                      } @else if (group.get('responseCode')?.value === 403) {
                        {{"gather.error.inaccessible" | translate}}
                      } @else if (group.get('responseCode')?.value === 404) {
                        {{"gather.error.not-found" | translate}}
                      } @else {
                        {{"gather.error.general" | translate}}
                      }
                    </mat-error>
                  }
                </mat-form-field>
                @if (group.get('showPassword')?.value) {
                  <div class="password-field-container">
                    <mat-form-field class="full-width blue-underline" subscriptSizing="dynamic">
                      <mat-label>{{"talent-happy-path.quick-apply.submit-page.password" | translate}}</mat-label>
                      <input matInput
                        [type]="group.get('hidePassword')?.value ? 'password' : 'text'"
                        formControlName="password">
                      <button type="button" mat-icon-button matSuffix (click)="group.get('hidePassword')?.setValue(!group.get('hidePassword')?.value)">
                        <mat-icon class="visibility-icon">{{ group.get('hidePassword')?.value ? 'visibility' : 'visibility_off' }}</mat-icon>
                      </button>
                      @if (group.get('password')?.hasError('maxlength')) {
                        <mat-error>
                          {{ 'talent-happy-path.quick-apply.submit-page.password-char-limit' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                <div class="password-toggle-row">
                  <mat-slide-toggle class="password-toggle"
                    color="primary"
                    formControlName="showPassword"
                    (change)="onShowPasswordChange(group)"
                    [attr.aria-label]="('talent-happy-path.quick-apply.submit-page.add-password' | translate) + ' ' + (i + 1)">
                    {{ 'talent-happy-path.quick-apply.submit-page.password-toggle-label' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            }
          </div>

          <div class="add-action-row">
            <button type="button" mat-button class="add-button" (click)="addPortfolioUrl()" [disabled]="!canAddMore">
              <mat-icon>add</mat-icon>
              <span>{{ 'talent-happy-path.quick-apply.submit-page.add-portfolio' | translate }}</span>
            </button>
          </div>
        </div>

        @if (form.hasError('tooManyLinks')) {
          <small class="error">{{ 'talent-happy-path.quick-apply.submit-page.too-many-links' | translate }}</small>
        }
      </div>
    </div>

    @if (errorMessage) {
      <small class="error">{{errorMessage | translate}}</small>
    }

    <button class="submit-button" (click)="submitAvailability()" [disabled]="submitDisabled">
      @if (this.hasPreInterviewQuestions) {
        <span>{{'gather.availability.next' | translate}}</span>
      } @else {
        <span>{{'gather.availability.submit' | translate}}</span>
      }
    </button>
  </form>
</div>
